import { useState, useEffect } from "react";

import AllRoutes from "../routes";

import Sidebar from "./organisms/Header/Sidebar";
import TopHeader from "./organisms/Header/TopHeader";

// import Footer from "./organisms/Footer";

export default function DefaultLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    return JSON.parse(localStorage.getItem("sidebar")) || false;
  });

  useEffect(() => {
    localStorage.setItem("sidebar", JSON.stringify(collapsed));
  }, [collapsed]);

  return (
    <>
      <div className="layout">
        <Sidebar collapsed={collapsed} />
        <div className="main">
          <TopHeader toggleSidebar={() => setCollapsed(!collapsed)} />
          <div className="content">
            <div className="container">
              <AllRoutes />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
